import { Languages } from "../../types";
import { loginDictionary } from "./login";
import { SecurityPagesDescriptions } from "./types";

export const getSecurityDescriptions = (systemLang: Languages): SecurityPagesDescriptions => ({
    LOGIN: loginDictionary[systemLang],
})